module.exports = __webpack_public_path__ + "media/images/rank/diamond-lg-ed3b5d34868ae02eb1af2e8d0b9f862e.svg";